import React from "react";
import VendorComponent from "./VendorComponent";
import Uri from "../../Network/Uri";
import {
  ADD_VENDOR,
  GET_VENDORS,
  UPDATE_VENDOR,
  DELETE_VENDOR,
} from "../../Network/ApiPaths";
import postClientDataResponse from "../../Network/PostClientDataResponse";
import getResponseClient from "../../Network/GetClientDataResponse";

let storeFresh;
let clientHost;

class VendorContainer extends React.Component {
  constructor(props) {
    super(props);
    const client = window.localStorage.getItem("clientAccess");
    storeFresh = JSON.parse(client);
    if (storeFresh !== null) {
      clientHost = storeFresh.host;
    }
    const hiddenVendors = JSON.parse(
      window.localStorage.getItem("hiddenVendors") || "[]"
    );
    this.state = {
      vendors: [],
      hiddenVendors: hiddenVendors,
      vendor_name: "",
      acct_number: "",
      bank_details: "",
      address: "",
      phone_number: "",
      gst: "",
      item_of_supply: "",
    };
  }

  componentDidMount() {
    this.getVendors();
  }

  onNameChange = (e) => this.setState({ vendor_name: e.target.value });
  onAccountChange = (e) => this.setState({ acct_number: e.target.value });
  onBankChange = (e) => this.setState({ bank_details: e.target.value });
  onAddressChange = (e) => this.setState({ address: e.target.value });
  onPhoneChange = (e) => this.setState({ phone_number: e.target.value });
  onGSTChange = (e) => this.setState({ gst: e.target.value });
  onItemofsupplyChange = (e) => this.setState({ item_of_supply: e.target.value });

  addVendor = (e) => {
    e.preventDefault();
    const requestBody = {
      vendor_name: this.state.vendor_name,
      acct_number: this.state.acct_number,
      bank_details: this.state.bank_details,
      address: this.state.address,
      phone_number: this.state.phone_number,
      gst: this.state.gst,
      item_of_supply: this.state.item_of_supply,
      store_id: storeFresh.storeId,
    };
    postClientDataResponse(
      clientHost + ADD_VENDOR,
      storeFresh.key,
      requestBody,
      () => this.getVendors(),
      (err) => console.log(err)
    );
  };

  getVendors = () => {
    const apiPath = new Uri(clientHost + GET_VENDORS)
      .addQueryParam("store_id", storeFresh.storeId);

    getResponseClient(
      apiPath,
      storeFresh.key,
      (res) => {
        const hiddenVendors = this.state.hiddenVendors;

        const visibleVendors = (res.result || []).filter(
          (vendor) => !hiddenVendors.includes(String(vendor.id))
        );

        this.setState({
          vendors: visibleVendors,
        });
      },
      (err) => {
        console.log(err);
      }
    );
  };

  deleteVendor = (id) => {
    console.log("Deleting Vendor ID:", id);

    const apiPath = new Uri(clientHost + DELETE_VENDOR)
      .addQueryParam("id", id);
    getResponseClient(
      apiPath,
      storeFresh.key,
      (res) => {
        console.log("Delete Vendor Response:", res);
        this.getVendors();
      },
      (err) => {
        console.error("Delete Vendor Error:", err);
      }
    );
  };

  updateVendor = (vendor) => {

    console.log("Updating Vendor");
    console.log(vendor);

    const requestBody = {
      id: vendor.vendor_id,
      vendor_name: vendor.vendor_name,
      acct_number: vendor.acct_number,
      bank_details: vendor.bank_details,
      address: vendor.address,
      phone_number: vendor.phone_number,
      gst: vendor.gst,
      item_of_supply: vendor.item_of_supply,
    };

    postClientDataResponse(
      clientHost + UPDATE_VENDOR,
      storeFresh.key,
      requestBody,
      () => {

        this.getVendors();

      },
      (err) => {

        console.log(err);

      }
    );
  };

  render() {
    return (
      <VendorComponent
        vendors={this.state.vendors}
        onNameChange={this.onNameChange}
        onAccountChange={this.onAccountChange}
        onBankChange={this.onBankChange}
        onAddressChange={this.onAddressChange}
        onPhoneChange={this.onPhoneChange}
        onGSTChange={this.onGSTChange}
        onItemofsupplyChange={this.onItemofsupplyChange}
        addVendor={this.addVendor}
        deleteVendor={this.deleteVendor}
        updateVendor={this.updateVendor}
      />
    );
  }
}

export default VendorContainer;
